// @ts-nocheck
/* Custom */
import "@/utils/disable-hash-jump";

/* Lazyloading */
import "lazysizes";
import "lazysizes/plugins/unveilhooks/ls.unveilhooks";

import { library } from "@fortawesome/fontawesome-svg-core";
import { faHouseChimney, faMoneyBill, faLocationDot, faBed, faBath, faBuilding, faGraduationCap, faShop, faBox, faChevronRight, faChevronDown, faClose, faSquareParking, faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
library.add(faHouseChimney);
library.add(faMoneyBill);
library.add(faLocationDot);
library.add(faBed);
library.add(faBath);
library.add(faBuilding);
library.add(faGraduationCap);
library.add(faShop);
library.add(faBox);
library.add(faChevronRight);
library.add(faChevronDown);
library.add(faClose);
library.add(faSquareParking);
library.add(faTimes);

// Plyr
import VuePlyr from "vue-plyr";
import "vue-plyr/dist/vue-plyr.css";

// AOS
import AOS from "aos";
AOS.init({
    offset: 120, // offset (in px) from the original trigger point
    delay: 0, // values from 0 to 3000, with step 50ms
    duration: 400, // values from 0 to 3000, with step 50ms
    easing: "ease", // default easing for AOS animations
    once: true, // whether animation should happen only once - while scrolling down
    mirror: false, // whether elements should animate out while scrolling past them
    anchorPlacement: "top-bottom", // defines which position of the element regarding to window should trigger the animation
});

/* Vue */
import { createApp } from "vue";
import VueGoogleMaps from "@fawmi/vue-google-maps";
import { createPinia } from "pinia";
import App from "./app.vue";
import SvgVue from "svg-vue3";
import { VueReCaptcha } from "vue-recaptcha-v3";
import StickyHeader from "./components/elements/sticky-header.vue";
import Slideout from "./components/elements/slideout.vue";
import SlideoutNavigation from "./components/elements/slideout-navigation.vue";

import ProjectsGrid from "./components/projects-grid.vue";
import ProjectsList from "./components/projects-list.vue";
import OtherProjectsList from "./components/other-projects-list.vue";
import SoldProjectsGrid from "./components/sold-projects-grid.vue";
import EstatesFilter from "./components/estates-filter.vue";
import TeamGrid from "./components/team-grid.vue";
import AppointmentForm from "./components/appointment-form.vue";
import ViewingDaysForm from "./components/viewing-days-form.vue";
import LeadsForm from "./components/leads-form.vue";
import NewsletterForm from "./components/newsletter-form.vue";
import GoogleMap from "./components/google-map.vue";
import ImageSlider from "./components/image-slider.vue";
import ElVideo from "./components/el-video.vue";

import DownloadBrochureModal from "./components/download-brochure-modal.vue";
import DownloadBrochureForm from "./components/download-brochure-form.vue";

import WhisePrice from "./components/elements/whise-price.vue";
import WhisePurpose from "./components/elements/whise-purpose.vue";
import WhiseDetails from "./components/elements/whise-details.vue";

import ModalWrapper from "./modals/modal-wrapper";

document.addEventListener("DOMContentLoaded", (event) => {
    initVh();
    window.addEventListener("resize", () => {
        initVh();
    });
    window.addEventListener("orientationchange", () => {
        initVh();
    });
    function initVh() {
        let vh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty("--vh", `${vh}px`);
    }
});

createApp(App)
    .use(createPinia())
    .use(VuePlyr, { plyr: {} })
    .use(SvgVue)
    .use(VueGoogleMaps, { load: { key: "AIzaSyAgI6V9ey3xmHFQxSAsssUadTh988g7lvU" } })
    .use(VueReCaptcha, {
        siteKey: RECAPTCHA_SITE_KEY,
        loaderOptions: { autoHideBadge: true },
    })
    .component("StickyHeader", StickyHeader)
    .component("SlideoutNavigation", SlideoutNavigation)
    .component("ProjectsGrid", ProjectsGrid)
    .component("EstatesFilter", EstatesFilter)
    .component("ProjectsList", ProjectsList)
    .component("OtherProjectsList", OtherProjectsList)
    .component("SoldProjectsGrid", SoldProjectsGrid)
    .component("TeamGrid", TeamGrid)
    .component("AppointmentForm", AppointmentForm)
    .component("ViewingDaysForm", ViewingDaysForm)
    .component("LeadsForm", LeadsForm)
    .component("NewsletterForm", NewsletterForm)
    .component("ElVideo", ElVideo)
    .component("GoogleMap", GoogleMap)
    .component("ImageSlider", ImageSlider)
    .component("FaIcon", FontAwesomeIcon)
    .component("WhisePrice", WhisePrice)
    .component("WhisePurpose", WhisePurpose)
    .component("WhiseDetails", WhiseDetails)
    .component("DownloadBrochureModal", DownloadBrochureModal)
    .component("DownloadBrochureForm", DownloadBrochureForm)
    .component("ModalWrapper", ModalWrapper)
    .mount("#app");
